import React, { useState, useEffect } from "react";
import s from "./About.module.css";
import Mauro from "../../assets/images/wp10.jpg";
import { Link } from "react-scroll";

import { motion } from "framer-motion";

const About = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true); // Trigger animation when in view
        }
      },
      { threshold: 0.2 } // Adjust threshold as needed
    );

    const aboutSection = document.querySelector(`#about`);
    if (aboutSection) {
      observer.observe(aboutSection);
    }

    return () => {
      if (aboutSection) {
        observer.unobserve(aboutSection);
      }
    };
  }, []);
  const sharedAnimationProps = {
    initial: { opacity: 0, scale: 0.8 },
    animate: isVisible ? { opacity: 1, scale: 1 } : {},
    // transition: { ease: "easeInOut" },
  };

  return (
    <div id="about" className={s.home_container}>
      <h1 className={s.main_title}>Hakkımızda</h1>
      <div className={s.content}>
        <div className={s.left_container}>
          {/* <h1 {...sharedAnimationProps} className={s.left_title}>
            Havacılık Kalite ve Tedarikçi Yönetimi Danışmanı
          </h1> */}
          <p style={{ marginTop: "24px" }} className={s.left_description}>
            24 yılı Havacılık motorları sektöründe olmak üzere toplam 26 yılı
            aşkın deneyimimizle edindiğimiz bilgi ve tecrübelerimizi paylaşmak
            için attığımız adımla 02 Aralık 2024 tarihinde{" "}
            <span style={{ fontWeight: "700" }}>AVIDEF Danışmanlık</span> doğdu.
          </p>
          <p className={s.left_description}>
            Bu süreçte{" "}
            <span style={{ fontWeight: "700" }}>
              kalite yönetimi, kalite yönetim sistemleri ve tedarikçi geliştirme
            </span>{" "}
            alanlarında edindiğimiz uzmanlık ve sektörel birikimi, şirketlere
            özel çözümlerle desteklemek amacıyla bu adımı atmış bulunuyoruz.
          </p>
          <p className={s.left_description}>
            Bu yeni yolculuğumuzda birlikte ilerlemek, deneyimlerimizi paylaşmak
            ve başarılar inşa etmek için sabırsızlanıyoruz.
          </p>
          <p
            style={{ fontWeight: "700", color: "var(--primary)" }}
            className={s.left_description}
          >
            AVIDEF Nedir?{" "}
          </p>

          <p className={s.left_description}>
            AVIDEF, Havacılık ve Savunma Sanayii sektörünün zorluklarına yönelik
            profesyonel danışmanlık hizmetleri sunmak ve işletmelerin kalite &
            kalite yönetim sistemlerindeki süreçlerini güçlendirmek, tedarikçi
            performansını optimize etmek, doküman yönetim sistemlerini kurmak,
            özelleştirilmiş yazılım çözümleri sunmak ve sunucu kurulumları gibi
            stratejik çözümler geliştirmek için yola çıktı.
          </p>

          <div className={s.buttons}>
            <Link
              smooth={true}
              duration={500}
              to="timeline"
              className={s.left_button}
              style={{ marginRight: "16px" }}
            >
              Neden Biz?
            </Link>
            <a
              href="/CV.pdf" // Dosyanızın yolu
              download="NazifGüngör_CV.pdf" // İndirildiğinde dosya adı
              className={s.left_button}
            >
              Sunacağımız Hizmet Alanları
            </a>
          </div>
        </div>
        <div className={s.right_container}>
          <img
            {...sharedAnimationProps}
            transition={{ ...sharedAnimationProps.transition, duration: 1 }}
            className={s.right_image}
            src={Mauro}
          />
        </div>
      </div>
    </div>
  );
};

export default About;
